import styled from 'styled-components'
import { Button } from 'react-bootstrap'

export { PageHeader, PageTitle, MeetingRoomToolbarActions } from '../pageLayoutStyles'

export const DetailActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`

export const HideSpaceButton = styled(Button)`
  &&& {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 32px;
    padding: 4px 12px;
    background: #fff;
    border: 1px solid #0072bc;
    border-radius: 4px;
    color: #0072bc;
    font-weight: 700;
    font-size: 14px;
    line-height: 1;
    box-shadow: none;
    white-space: nowrap;
  }

  svg {
    font-size: 14px;
  }

  &&&:hover,
  &&&:focus,
  &&&:active,
  &&&:disabled {
    background: #fff;
    border-color: #0072bc;
    color: #0072bc;
    box-shadow: none;
  }
`
